import React, {createContext, useContext, useState} from 'react';

const EventContext = createContext({page: 0, size: 10, searchWrd: '', exposureYn: ''});

const EventProvider = ({children}) => {
    const [options, setOptions] = useState({page: 0, size: 10, searchWrd: '', exposureYn: ''});

    const value = {
        options,
        setOptions,
    };

    return (
        <EventContext.Provider value={value}>
            {children}
        </EventContext.Provider>
    );
};

const useEventContext = () => {
    return useContext(EventContext);
};

export {EventProvider, useEventContext};
